import React from 'react';
import { observer, inject } from 'mobx-react';
import MainLayout from './MainLayout';
import * as _ from '../../util/public/common';
import * as DetailUtil from '../../util/public/detailUtil';
import { appendDefaultPath } from './../../util/formUtil';

@inject('globalStore', 'layoutStore')
@observer
export default class TabLayout extends React.Component {
    
    componentDidMount() {
        const { cellMark, layoutStore } = this.props;
        const { cellInfo } = layoutStore;
        const style = cellInfo[`main_${cellMark}_stylejson`];
        const tabBar = jQuery(this.refs.tabBar);
        const tab_head = tabBar.parent();
        const tab_top = tab_head.parent();
        const tab_turnleft = tab_top.find(".tab_turnleft");
        const tab_turnright = tab_top.find(".tab_turnright");
        let totalWidth = 0;
        let tabTopWidth = tab_top.width()
        tabBar.children().each(function () {
            let thisWidth = jQuery(this)[0].getBoundingClientRect().width;

            if (thisWidth >= tabTopWidth) {
                let className = ""
                if (jQuery(this)[0] && jQuery(this)[0].className) {
                    className = jQuery(this)[0].className;
                }
                if (className.includes("t_unsel")) {
                    thisWidth = thisWidth + Number(style.unsel_bgrightwidth) + Number(style.unsel_bgleftwidth);
                } else if (className.includes("t_sel")) {
                    thisWidth = thisWidth + Number(style.sel_bgrightwidth) + Number(style.unsel_bgleftwidth);
                }
            }
            totalWidth += thisWidth;
        });
        if (totalWidth > tab_top.width()) {
            tab_top.find(".tab_movebtn").css("display", "block");
            tab_head.width(tab_top.width() - tab_turnleft.width() - tab_turnright.width() - 5);
            tabBar.width(totalWidth + 1);
        } else {
            tab_top.find(".tab_movebtn").css("display", "none");
            tab_head.width("100%");
            tabBar.width("100%");
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const showid = this.props.showid;
        if (showid !== prevProps.showid) {   //切换了标签显示区域
            //window.formImgLazyLoad(jQuery(`div#${showid}_content`));    //执行图片懒加载
            window.formImgLazyLoad(jQuery('.wf-req-form-scroll'));
            DetailUtil.calculateDetailAreaStyle(jQuery("#" + showid + "_content"));
            window.WfForm.triggerAction(window.WfForm.ACTION_SWITCHTABLAYOUT, [showid]);
        }
    }
    render() {
        const { cellMark, tab, showid, globalStore, layoutStore } = this.props;
        const { JSComplete,commonParam={} } = globalStore;
        const { isprint }=commonParam;
        const { dataJson, cellInfo, propFileCfg={} } = layoutStore;
        const { print_show_allTabs } = propFileCfg;
        const style = cellInfo[`main_${cellMark}_stylejson`];
        if (!style)
            return <div>Empty TabArea Style</div>

        let contentStyle = {};
        const areaheight = tab.areaheight;
        if (areaheight && areaheight.indexOf("2,") > -1) {     //固定高度
            contentStyle["height"] = areaheight.split(",")[1] + "px";
            contentStyle["overflow-y"] = "auto";
        }
        let tabArr = new Array();
        _.forIn(tab, (v, k) => {
            if (k.indexOf("order_") === 0 && v && v.indexOf(",") > -1) {
                const arr = v.split(",");
                tabArr.push({
                    id: arr[0],
                    name: arr[1],
                    order: parseInt(k.substring(6))
                });
            }
        });
        tabArr = tabArr.sort((a, b) => {
            return a.order - b.order;
        });
        let defShowIndex = parseInt(tab.defshow || 0);
        if (defShowIndex >= tabArr.length)
            defShowIndex = 0;

        const tabShowSymbol = showid === "" ? tabArr[defShowIndex].id : showid;
        let tabHeadBar = new Array();
        let tabContent = new Array();
        tabArr.map((v, k) => {
            const tabid = v.id;
            //拼标签头部bar
            const sel = tabid === tabShowSymbol ? "sel" : "unsel";
            let middleStyle = {
                backgroundImage: "url('" + appendDefaultPath(style[sel + "_bgmiddle"])+ "')",
                fontSize: style[sel + "_fontsize"] + "px",
                color: style[sel + "_color"],
                fontFamily: style[sel + "_family"]
            };
            if (style && style[sel + "_bold"] == "1")
                middleStyle["font-weight"] = "bold";
            if (style && style[sel + "_italic"] == "1")
                middleStyle["font-style"] = "italic";
            tabHeadBar.push(
                <div id={tabid} className={"t_" + sel} onClick={this.changeTab.bind(this, tabid)}>
                    <div className={"t_" + sel + "_left norepeat"}
                        style={{
                            backgroundImage: "url('" +appendDefaultPath(style[sel + "_bgleft"]) + "')",
                            width: style[sel + "_bgleftwidth"] + "px"
                        }}>
                    </div>
                    <div className={"t_" + sel + "_middle xrepeat lineheight30"} style={middleStyle}>
                        <span style={{ "whiteSpace": "nowrap" }}>{v.name}</span>
                    </div>
                    <div className={"t_" + sel + "_right norepeat"}
                        style={{
                            backgroundImage: "url('" + appendDefaultPath(style[sel + "_bgright"] )+ "')",
                            width: style[sel + "_bgrightwidth"] + "px"
                        }}>
                    </div>
                </div>
            );
            if (k !== tabArr.length - 1) {
                tabHeadBar.push(<div className="t_sep norepeat" style={{ width: style.image_sepwidth + "px" }}></div>);
            }
            //拼接标签页内容
            tabContent.push(
                <div className={`tab_content${isprint == 1 && print_show_allTabs == 1  ? " print-force-show-tab" : ""}`} id={tabid + "_content"} style={tabid === tabShowSymbol ? {} : { display: "none" }}>
                    <MainLayout ecId={`${this && this.props && this.props.ecId || ''}_MainLayout@7yvwso@${tabid}`} symbol={tabid} />
                </div>
            );
        });
        return (
            <div className={`tab_area tabarea_${cellMark}`}>
                <div className="tab_top">
                    <div className="tab_movebtn tab_turnleft" style={{display:"none"}} onClick={this.turnBar.bind(this, "left")}></div>
                    <div className="tab_head" style={{ width: "100%" }}>
                        <div className="t_area xrepeat" ref="tabBar"
                            style={{
                                backgroundImage: "url(" + appendDefaultPath(style.image_bg )+ ")",
                                width: "100%"
                            }}>
                            {tabHeadBar}
                        </div>
                    </div>
                    <div className="tab_movebtn tab_turnright" style={{display:"none"}} onClick={this.turnBar.bind(this, "right")}></div>
                </div>
                <div className="tab_bottom" style={contentStyle}>
                    {tabContent}
                </div>
            </div>
        )
    }
    changeTab(selectedTabId) {
        const { cellMark, layoutStore } = this.props;
        layoutStore.controlVariableMap(`tabarea_${cellMark}_showid`, selectedTabId);
    }
    turnBar(flag) {
        const tab_head = jQuery(this.refs.tabBar).parent();
        if (flag === "left")
            tab_head.scrollLeft(tab_head.scrollLeft() - 80);
        else if (flag === "right")
            tab_head.scrollLeft(tab_head.scrollLeft() + 80);
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/layout/TabLayout.js